import store from '@/store/store';

export default {
  path: 'members/:id',
  name: 'app-view-member',
  component: () => import('@/views/app/view_member/ViewMember.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    //to.meta.pageTitle = 'view_member.header_title';

    const membersResource = await store.state.router.privateRoot.$request().$get('members');
    store.commit('router/updateRouteProp', {
      property: 'membersResource',
      value: membersResource
    });

    const memberResource = await membersResource.$request().$get('member', {id: to.params.id});
    store.commit('router/updateRouteProp', {
      property: 'memberResource',
      value: memberResource
    });

    next();
  },
  props: () => ({
    memberResource: store.state.router.memberResource
  })
};